import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';

// ==============================|| ROLE GUARD ||============================== //
// allow listesinde bulunmayan kullanici_tipi ile erişilmeye çalışılırsa
// kullanıcı kendi ana sayfasına ('/') yönlendirilir (Uç Durum 9).
// '/' her zaman izin verilen bir hedef kabul edilir; aksi halde bu fazın
// kapsamındaki 'yonetici'/'bina_sakini' dışında bir kullanici_tipi (örn.
// 'bina_calisani') '/' rotasına da erişemezse sonsuz yönlendirme döngüsüne girer.

export default function RoleGuard({ allow, children }) {
  const { kullaniciTipi } = useAuth();
  const { pathname } = useLocation();

  if (pathname !== '/' && !allow.includes(kullaniciTipi)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

RoleGuard.propTypes = { allow: PropTypes.arrayOf(PropTypes.string).isRequired, children: PropTypes.node };
